import { sample, createStore, createEvent } from 'effector'
import { isRequestPolicyEnforced } from '~/core/api'
import { onBucketsUpdate } from '~/core/api/policies'
import { hooks } from '!/router'
import { nay, T, F } from '~/shared/helpers'

export const $show = createStore(false)

const navigationInitHook = createEvent()

// register the navigation hook
hooks.register(hooks.Init, navigationInitHook)

// hide notification, after successfull redirect to some new route
sample({
  clock: navigationInitHook,
  filter: () => nay(isRequestPolicyEnforced()),
  fn: F,
  target: $show,
})

// show notification as soon as some restrictions appear
sample({
  clock: [onBucketsUpdate, navigationInitHook],
  filter: isRequestPolicyEnforced,
  fn: T,
  target: $show,
})
